require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./es-locations-carretera-masaya.json") })
        }
      }, "path---es-locations-carretera-masaya");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---es-locations-carretera-masaya!./.cache/json/es-locations-carretera-masaya.json
// module id = 1101
// module chunks = 231608221292675